import { css } from "styled-components";

import { colorCSS } from "./colors";
import { redundantCssFromKebab } from "./redundant-css";
import { fontSizes } from "./textSize";

export const tableCSS: ReturnType<typeof css> = css`
    table {
        ${redundantCssFromKebab("background-color", `${colorCSS("N0")}`)}
        ${redundantCssFromKebab("color", `${colorCSS("N900")}`)}
        ${redundantCssFromKebab("display", "block")}
        ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
        ${redundantCssFromKebab("margin-block-end", "1.5rem")}
        ${redundantCssFromKebab("overflow-x", "auto")}
        ${redundantCssFromKebab("width", "100%")}
        th {
            ${redundantCssFromKebab("background-color", `${colorCSS("N20")}`)}
        }
        th,
        td {
            ${redundantCssFromKebab("border", `1px solid ${colorCSS("N40")}`)}
            ${redundantCssFromKebab("padding", "0.33rem 0.5rem")}
            ${redundantCssFromKebab("vertical-align", "top")}
        }
    }
`;
